import { render, staticRenderFns } from "./AlertsEdit.vue?vue&type=template&id=ac30c0f0&"
import script from "./AlertsEdit.vue?vue&type=script&lang=js&"
export * from "./AlertsEdit.vue?vue&type=script&lang=js&"
import style0 from "./AlertsEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports